"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuestionSummary = void 0;
var _constants = require("../../../utils/constants");
var _services = require("../../../services");
var getChoicesSummaryValue = function getChoicesSummaryValue(selections) {
  var _summaryDelimiter$;
  var summaryDelimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (selections.length === 1) {
    return selections[0];
  }
  var firstSelections = selections.slice(0, -1);
  var lastSelection = selections.slice(-1);
  var firstDelimiter = summaryDelimiter[0];
  var lastDelimiter = (_summaryDelimiter$ = summaryDelimiter[1]) !== null && _summaryDelimiter$ !== void 0 ? _summaryDelimiter$ : summaryDelimiter[0];
  return [firstSelections.join(firstDelimiter), lastSelection].join(lastDelimiter);
};
var parseSummaryTpl = function parseSummaryTpl(tpl, value) {
  var jsonName, jsonStreetNumber;
  try {
    jsonName = JSON.parse(value).name;
    jsonStreetNumber = JSON.parse(value).selectedStreetNr;
  } catch (_unused) {
    jsonName = '';
    jsonStreetNumber = '';
  }
  return tpl.replace('{{value}}', "<value>".concat(value, "</value>")).replace('{{currencyValue}}', "<value>".concat(_services.locale.formatPrice(value, {
    fraction: false
  }), "</value>")).replace('{{addressValue}}', "<value>".concat(jsonName, ", ").concat(jsonStreetNumber, "</value>"));
};
var getQuestionSummary = function getQuestionSummary(question, selections) {
  var summaryTpl = question.summary;
  switch (question.type) {
    case _constants.QUESTION_TYPE.CHOICES:
      {
        if (question.summaryMaxSelections && selections.length > question.summaryMaxSelections) {
          return;
        }
        if (selections.length === 1) {
          var choice = question.choices.find(function (c) {
            return selections.includes(c.text);
          });
          if (choice.summary) {
            summaryTpl = choice.summary;
          }
        }
        if (!summaryTpl || summaryTpl === '-') {
          return;
        }
        selections = question.choices.filter(function (c) {
          return selections.includes(c.text);
        }).map(function (c) {
          return c.summaryText || c.text;
        }).map(function (selection) {
          return "<value>".concat(selection, "</value>");
        });
        var summaryValue = getChoicesSummaryValue(selections, question.summaryDelimiter);
        return summaryTpl.replaceAll('{{value}}', summaryValue);
      }
    case _constants.QUESTION_TYPE.MULTI:
      {
        if (!summaryTpl) {
          return;
        }
        selections.forEach(function (selection) {
          summaryTpl = parseSummaryTpl(summaryTpl, selection);
        });
        return summaryTpl;
      }
    default:
      {
        if (!summaryTpl) {
          return;
        }
        var _summaryValue = selections[0];
        return parseSummaryTpl(summaryTpl, _summaryValue);
      }
  }
};
exports.getQuestionSummary = getQuestionSummary;